// extracted by mini-css-extract-plugin
module.exports = {"surveyLink":"WFARm","root":"_38vNt","backgroundDark":"_33D1L","surveyText":"_2XhSx","surveyDismissIcon":"_3DlZ7","message":"_2b_lY","themeGreen":"_2PcUI","globeIcon":"xOsom"};